import APIServiceLookUp from './serviceAPI';
import { MAIN_API_URL } from './models/AppConstent';

export default class ServiceCRM {
    lookupService = new APIServiceLookUp();

    async checkByPhone(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}crm/checkByPhone`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getAllCust(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}crm/getAllCust`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }
}